export default __webpack_public_path__ + "static/media/Unaniem_W.18044b83.png";